import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LogOut, User as UserIcon, Globe } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import T from './T';

const Navbar: React.FC = () => {
  const { user, role, logout } = useAuth();
  const { language, setLanguage } = useLanguage();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'zh' : 'en');
  };

  return (
    <nav className="navbar navbar-root" style={{
      backgroundColor: '#FFFFFF', // Changed to white
      color: '#9E9E9E', // Updated font color
      backdropFilter: 'none',
      borderBottom: '1px solid #a7afb7',
      padding: '1rem 2rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: 'var(--shadow)',
      position: 'sticky',
      top: 0,
      zIndex: 1000,
      transition: 'var(--transition)'
    }}>
      <Link to="/" className="navbar-brand" style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src="/yliulogo.png"
          alt="Y. Liu Law Firm logo"
          style={{ height: '50px', width: 'auto', display: 'block' }}
        />
      </Link>
      
      <div className="navbar-actions" style={{ display: 'flex', gap: '1.5rem', alignItems: 'center' }}>
        <button 
          onClick={toggleLanguage}
          style={{ 
            background: '#d2d7dc', 
            color: '#111111', 
            padding: '0.5rem 1rem', 
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            border: '1px solid #a7afb7',
            fontWeight: 'bold',
            boxShadow: 'none'
          }}
        >
          <Globe size={18} />
          {language === 'en' ? '中文' : 'English'}
        </button>
        <Link to="/" style={{ color: '#111111', textShadow: 'none' }}><T>Home</T></Link>
        <a href="/#our-team" style={{ color: '#111111', textShadow: 'none' }}><T>Our Team</T></a>
        <Link to="/articles" style={{ color: '#111111', textShadow: 'none' }}><T>Articles</T></Link>
        <Link to="/contact" style={{ color: '#111111', textShadow: 'none' }}><T>Contact</T></Link>
        {user ? (
          <>
            <Link to={`/${role}`} style={{ color: '#111111', textShadow: 'none' }}><T>Dashboard</T></Link>
            {(role === 'admin' || role === 'lawyer') && (
              <Link to="/intake" style={{ color: '#111111', textShadow: 'none' }}><T>Intake</T></Link>
            )}
            <button 
              onClick={handleLogout}
              style={{ background: 'transparent', color: '#111111', display: 'flex', alignItems: 'center', gap: '0.3rem', textShadow: 'none' }}
            >
              <LogOut size={18} /> <T>Logout</T>
            </button>
            <Link to="/profile" style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '0.5rem', 
              borderLeft: '1px solid #8e99a4', 
              paddingLeft: '1rem', 
              color: '#111111',
              textShadow: 'none'
            }}>
              <UserIcon size={18} />
              <span style={{ fontSize: '0.9rem' }}>{role?.toUpperCase()}</span>
            </Link>
          </>
        ) : (
          <Link to="/login" className="btn btn-secondary" style={{ color: '#ffffff' }}><T>Login</T></Link>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
